<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="cancel()">×</button>
    <h4 class="modal-title wrap-text-in" *ngIf="changeToState === 'SoftHold'">Soft Hold Company</h4>
    <h4 class="modal-title wrap-text-in" *ngIf="changeToState !== 'SoftHold'">{{changeToState}} Company</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12" *ngIf="changeToState === 'Delete'">
            <app-delete-entity
                entity="company"
                [companyInfo]="companyInfo"
                [sourceScreen]="'COMPANY_EDIT'"
                (cancelCallback)="cancel()"
                (deleteCallback)="onCompanyDelete()">
            </app-delete-entity>
        </div>
        <div class="col-xs-12" *ngIf="changeToState !== 'Delete'">
            <form role="form" name="actionform" #actionform="ngForm" *ngIf="!isLoading" id="actionform"
                (ngSubmit)="actionform.valid && changeCompanyState()" novalidate>
                <div class="form-group wrap-text-in">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-xs-6">
                                <label for="currentDate">Date</label>
                                <div class="input-group">
                                    <span class="input-group-addon">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                    <input type="text" class="form-control access" placeholder="mm-dd-yyyy"
                                        id="currentDate" name="currentDate" [ngModel]="date" required disabled>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <label for="time">Time</label>
                                <div class="input-group">
                                    <span class="input-group-addon">
                                        <i class="far fa-clock"></i>
                                    </span>
                                    <input type="text" class="form-control access" placeholder="hh:mm:ss"
                                        [ngModel]="time" id="time" name="time" required disabled>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" *ngIf="changeToState === 'SoftHold'"
                        [ngClass]="{'has-error': actionform.submitted && techAssessmentLimitForSoftHold?.invalid}">
                        <div class="row">
                            <div class="col-xs-6" *ngIf="!isTrialPlanActive">
                                <label for="techAssessmentLimitForSoftHold">Tech Assessments Limit:</label>
                                <div class="input-group">
                                    <input type="number" class="form-control access" id="techAssessmentLimitForSoftHold"
                                        name="techAssessmentLimitForSoftHold" #techAssessmentLimitForSoftHold="ngModel"
                                        [(ngModel)]="companyChangeStateObject.techAssessmentLimitForSoftHold" required>
                                    <small class="error"
                                        *ngIf="actionform.submitted && techAssessmentLimitForSoftHold.errors?.required">
                                        Limit is mandatory.
                                    </small>
                                </div>
                            </div>
                            <div class="col-xs-6" *ngIf="isTrialPlanActive">
                                <label for="assessmentsLeft">Tech Assessments Left:</label>
                                <span id="assessmentsLeft">{{assessmentsLeft}}</span>
                            </div>
                            <div class="col-xs-6" *ngIf="isTrialPlanActive">
                                <label for="jobBoardsPullLeft">Job Board Pulls Left:</label>
                                <span id="jobBoardsPullLeft">{{jobBoardsPullLeft}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group" [ngClass]="{'has-error': (actionform.submitted && note?.invalid)}">
                        <label>Note <em> * </em></label>
                        <div>
                            <div class="mb-2">
                                <app-voice-input (transcriptReady)="onVoiceTranscript($event)"
                                    sourceScreen="COMPANY_EDIT">
                                </app-voice-input>
                            </div>
                            <textarea name="note" #note="ngModel" class="form-control"
                                style="height: 100px; width: 100%;resize: none;" maxlength="503"
                                [(ngModel)]="companyChangeStateObject.note" required></textarea>
                        </div>
                        <div class="error error-gap" *ngIf="actionform.submitted">
                            <small *ngIf="note.errors?.required"><em>*</em>
                                Note is required
                            </small>
                        </div>
                        <app-formalize-comment [inputText]="companyChangeStateObject.note"
                            (outputText)="receiveFormalizedComment($event)" sourceScreen="COMPANY_EDIT">
                        </app-formalize-comment>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 text-right">
                            <div class="clearfix">
                                <button type="button" class="btn btn-danger mr-2" (click)="cancel()">Cancel</button>
                                <button type="submit" class="btn btn-success" [disabled]="changingStateFlag">
                                    <span *ngIf="!changingStateFlag">{{stateText}}</span>
                                    <span *ngIf="changingStateFlag">Changing State..</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div class="row" *ngIf="isLoading">
                <div class="col-xs-12">
                    <app-skeleton-loader variant="form" [rows]="3"></app-skeleton-loader>
                </div>
            </div>
        </div>
    </div>
</div>
